import React from 'react';
import { Button, Space } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { renderDeleteButton } from '../utils/renderHelpers';

/**
 * Reusable component for clone and delete action buttons
 */
export const ActionButtons = ({ onClone, onDelete, size = 'default', cloneTitle = 'Clone' }) => (
  <Space size={4}>
    {onClone && (
      <Button
        type="text"
        icon={<CopyOutlined />}
        onClick={onClone}
        size={size}
        title={cloneTitle}
      />
    )}
    {onDelete && renderDeleteButton(onDelete, size)}
  </Space>
);





